import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import SectionCard from "../../components/SectionCard";
import SectionRow from "../../components/SectionRow";
import { useCompanyDateFormat } from "utils/hooks/company";
import { dateTimeFormat } from "utils/helpers/date";

function KeyDates({ user }: any) {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();

    const formatDate = useCallback((date?: string) => {
        return date && moment(date).isValid()
            ? dateTimeFormat(date, dateFormat)
            : undefined;
    }, [dateFormat]);

    return (
        <SectionCard title={t("key-dates")}>
            <SectionRow label={t("status")} value={user?.status ? t(user.status) : undefined} />
            <SectionRow label={t("as-of")} value={formatDate(user?.statusStartDate)} />
            <SectionRow label={t("date-of-birth")} value={formatDate(user?.birthDate)} />
            <SectionRow label={t("original-hiring-date")} value={formatDate(user?.hiringDate)} />
            <SectionRow label={t("last-hire-date")} value={formatDate(user?.lastHireDate)} />
            <SectionRow label={t("termination-date")} value={formatDate(user?.terminatedAt)} />
            <SectionRow label={t("seniority-date")} value={formatDate(user?.dateOfSeniority)} />
        </SectionCard>
    );
}

export default KeyDates;
